import moment from "moment"
import { useCallback, useEffect } from "react"
import { ActivationObject } from "../../../providers/ActivationObjectProvider/types"
import { Step2FormConditionsProps, Step2FormOptionsProps, Step2FormProps } from "../types"
import { useHolidaysQuery } from "../../../../api/timeTerms/hooks"

const useStep2FormConditions = (
    form: Step2FormProps["form"],
    options: Step2FormOptionsProps,
    activationObject?: ActivationObject
): Step2FormConditionsProps => {
    const handoverHour = form.watch("handoverHour")
    const backHandoverHour = form.watch("backHandoverHour")
    const serviceSelected = form.watch("selectService")
    const { data: publicHolidays } = useHolidaysQuery()

    const { setValue } = form

    useEffect(() => {
        if (handoverHour) {
            if (options.handoverTimes && !options.handoverTimes.length) {
                setValue("handoverHour", undefined)
            }
            if (options.handoverTimes && !options.handoverTimes.some((x) => x.value === handoverHour)) {
                setValue("handoverHour", options.handoverTimes.length ? options.handoverTimes[0].value : undefined)
            }
        }
    }, [activationObject, handoverHour, options.handoverTimes, setValue])

    useEffect(() => {
        if (backHandoverHour) {
            if (options.handoverTimes && !options.handoverTimes.length) {
                setValue("backHandoverHour", undefined)
            }
            if (options.handoverTimes && !options.handoverTimes.some((x) => x.value === backHandoverHour)) {
                setValue("backHandoverHour", options.handoverTimes.length ? options.handoverTimes[0].value : undefined)
            }
        }
    }, [activationObject, backHandoverHour, options.handoverTimes, setValue])

    const isHoliday = (day: Date | string, currentHolidays?: string[]): boolean => {
        const formattedHolidays = currentHolidays?.map((holiday) => moment(holiday).format("DD.MM."))
        const formattedDay = moment(day).format("DD.MM.")

        return formattedHolidays?.includes(formattedDay) || false
    }

    const now = moment()
    let handoverMinDate = now.add(now.hours() < 14 ? 1 : 2, "day")
    if (isHoliday(handoverMinDate.toDate(), publicHolidays)) handoverMinDate = handoverMinDate.add(1, "day")
    if ((handoverMinDate.day() === 6 || handoverMinDate.day()) === 0 && (now.day() !== 4 || now.day() !== 5))
        handoverMinDate = handoverMinDate.add(2, "day")

    const isDayDisabled = useCallback((day: Date | string) => isHoliday(day, publicHolidays), [publicHolidays])

    const backHandoverDisabled = serviceSelected !== "BaseProtection" && !!activationObject?.isAvailableKey === true

    return {
        personType: activationObject?.personType || "Physical",
        // guaranteedTime: guaranteedTime ? guaranteedTime + ' minut' : undefined,
        handoverMinDate: handoverMinDate.toDate(),
        backHandoverDisabled,
        isDayDisabled,
    }
}

export default useStep2FormConditions
